import React from 'react';

function SHeader() {
  return (
		<header className="default-header">
			<div className="container-fluid">
				<div className="header-wrap">
					<div className="header-top d-flex justify-content-between align-items-center">
                    
						<div className="logo">
						</div>
							<div className="menu-bar">
                            <a href="/"><span className="lnr lnr-home mr-4" title="Main Home Page"></span></a>
                            <a href="/shop"><span className="lnr lnr-shirt" title="Shop Home Page"></span></a>
                            </div>
					</div>
				</div>
			</div>
		</header>
  );
}

export default SHeader;
